const CompanyAccounts = () => {
  return (
    <p>
      Your last set of filed accounts, in a PDF format. This should be the full
      version of the accounts including profit and loss and balance sheet,
      broken down by item.{' '}
      <a
        href="https://effective-accounting.co.uk/blog/what-is-included-in-my-company-accounts/"
        target="_blank"
        rel="noreferrer"
      >
        Learn more
      </a>
    </p>
  );
};

export default CompanyAccounts;
